export default __webpack_public_path__ + "static/media/liftoff.fb1ea6d6.jpg";